import React from "react";
import GuidePanel from "../GuidePanel.js";
import { GuideLead, GuideCallout } from "../GuideBlocks.js";

const IntroductionSection = ({ heading, accentIndex = 0, getVisual, getAccent }) => (
  <GuidePanel
    sectionId="introduction"
    heading={heading}
    accentIndex={accentIndex}
    getVisual={getVisual}
    getAccent={getAccent}
  >
    <GuideLead>
      Every decision we make, every relationship we build, and every challenge we face is influenced
      by one powerful force—our emotions.
    </GuideLead>
    <p className="guide-panel__p">
      Emotions are not the problem. The problem is often that we don't understand them.
    </p>
    <p className="guide-panel__p">
      Many of us were taught how to read, write, and solve mathematical problems, but very few of us
      were taught how to recognize what we feel, why we feel it, or how to choose a deliberate response.
    </p>
    <p className="guide-panel__p">
      Emotional awareness is the ability to notice, understand, and work with your emotions instead of
      being controlled by them.
    </p>
    <GuideCallout variant="amber">
      When you become emotionally aware, you stop reacting on autopilot. You begin making conscious
      choices.
    </GuideCallout>
    <GuideCallout>This guide will help you develop that skill.</GuideCallout>
  </GuidePanel>
);

export default IntroductionSection;
